import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EnTrans from "../lang/en.json";
import HiTrans from "../lang/hi.json";
import SpTrans from "../lang/es.json";
import FRTrans from "../lang/fr.json";
import ArTrans from "../lang/ar.json";
import BnTrans from "../lang/bn.json";
import PtTrans from "../lang/pt.json";
import UrTrans from "../lang/ur.json";
import RuTrans from "../lang/ru.json";
import ChTrans from "../lang/ch.json";

const resumePersonalLabels = [
  { translation: EnTrans, nameOtherName: "Other Name(s)", address: "Location" },
  { translation: HiTrans, nameOtherName: "अन्य नाम", address: "स्थान" },
  { translation: SpTrans, nameOtherName: "Otros nombres", address: "Ubicación" },
  { translation: FRTrans, nameOtherName: "Autre(s) nom(s)", address: "Emplacement" },
  { translation: ArTrans, nameOtherName: "أسماء أخرى", address: "الموقع" },
  { translation: BnTrans, nameOtherName: "অন্যান্য নাম", address: "অবস্থান" },
  { translation: PtTrans, nameOtherName: "Outro(s) nome(s)", address: "Localização" },
  { translation: UrTrans, nameOtherName: "دیگر نام", address: "مقام" },
  { translation: RuTrans, nameOtherName: "Другие имена", address: "Местоположение" },
  { translation: ChTrans, nameOtherName: "其他姓名", address: "位置" },
];

const joinButtonLabels = [
  { translation: EnTrans, joinNow: "Join For Free Today" },
  { translation: HiTrans, joinNow: "आज मुफ्त में शामिल हों" },
  { translation: SpTrans, joinNow: "Únete gratis hoy" },
  { translation: FRTrans, joinNow: "Inscrivez-vous gratuitement aujourd'hui" },
  { translation: ArTrans, joinNow: "انضم مجانًا اليوم" },
  { translation: BnTrans, joinNow: "আজই বিনামূল্যে যোগ দিন" },
  { translation: PtTrans, joinNow: "Junte-se gratuitamente hoje" },
  { translation: UrTrans, joinNow: "آج ہی مفت شامل ہوں" },
  { translation: RuTrans, joinNow: "Присоединяйтесь бесплатно сегодня" },
  { translation: ChTrans, joinNow: "立即免费加入" },
];

const translations = resumePersonalLabels.map(({ translation }) => translation);

resumePersonalLabels.forEach(({ translation, nameOtherName, address }) => {
  translation.nameOtherName = nameOtherName;
  translation.address = address;
});

joinButtonLabels.forEach(({ translation, joinNow }) => {
  translation.joinNow = joinNow;
  translation.joinForFree = joinNow;
  translation.joinForFreeToday = joinNow;
});

translations.forEach((translation) => {
  if (!translation.video && translation.vidoe) {
    translation.video = translation.vidoe;
  }

  if (translation.milestonesPages2023) {
    translation.milestonesPages2023 = translation.milestonesPages2023.replace(
      "Milestones Pages",
      "Milestones Page"
    );
  }
});

const userLanguage = navigator.language || navigator.userLanguage;
let lang = 'en';
let user_data = null;

try {
  user_data = JSON.parse(localStorage.getItem('user_data'));
} catch (e) {
  console.warn(e);
}

if (user_data?.profile?.lang) {
  localStorage.setItem('lang', user_data.profile.lang);
  lang = user_data.profile.lang;
} else {
  console.log(userLanguage); // e.g., 'en-US'
  lang = userLanguage || localStorage.getItem('lang') || 'en';
  if (userLanguage) {
    localStorage.setItem('lang', userLanguage);
  }
}



i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {translation: EnTrans},
      hi: {translation: HiTrans},
      es: {translation: SpTrans},
      fr: {translation: FRTrans},
      ar: {translation: ArTrans},
      bn: {translation: BnTrans},
      pt: {translation: PtTrans},
      ur: {translation: UrTrans},
      ru: {translation: RuTrans},
      ch: {translation: ChTrans}
      
    },
    lng: lang, // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

  export default i18n;